import { Box, Typography, useMediaQuery } from '@mui/material';
import React, { useEffect, useState } from 'react';
import createAxiosInstance from '../../api/axiosConfig';
import { PRIZES_API } from '../../api/endpoint';
import { useNavigate } from 'react-router-dom';

const Prizes = () => {
  const isMobile = useMediaQuery('(max-width:600px)');
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);
  const navigate = useNavigate();

  const getPrizes = async () => {
    setLoading(true);
    try {
      const axiosInstance = createAxiosInstance(false);
      const response = await axiosInstance.get(`${PRIZES_API}`, {});
      setData(response.data.data);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getPrizes();
  }, []);

  const handleClick = (item: any) => {
    navigate(`/prizes/${item.reward_id}`, {
      state: { item }
    });
  };

  return (
    <div>
      <Typography
        style={{
          fontFamily: 'Baloo2',
          fontSize: isMobile ? '24px' : '48px',
          fontWeight: 800,
          color: 'white',
          textAlign: 'center',
          paddingBottom: '40px'
        }}>
        ALL Prizes
      </Typography>
      <div
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: isMobile ? '12px' : '15px',
          margin: isMobile ? '0 10%' : '0 5%'
        }}>
        {data.map((item: any, index: number) => (
          <div
            key={index}
            onClick={() => handleClick(item)}
            style={{
              flex: isMobile ? 'flex: 1 1 calc(100% / 3 - 10px) ' : '1 1 calc(100% / 4 - 16px)',
              maxWidth: isMobile ? 'calc(100% / 3 - 16px)' : 'calc(100% / 4 - 16px)',
              textAlign: 'center',
              height: isMobile ? '150px' : '280px',
              width: isMobile ? '200px' : '150px',
              cursor: 'pointer'
            }}>
            <Box key={index} sx={{ alignItems: 'center', padding: '0 0 0 10px ' }}>
              <Box sx={{}}>
                <img
                  style={{
                    width: isMobile ? '100px' : '200px',
                    height: isMobile ? '100px' : '200px'
                  }}
                  src={`${process.env.REACT_APP_DEFAULT_AVATAR}/APP/PrizeAvatars/${item?.avatar}`}
                  alt={'prices'}></img>
              </Box>
              <Typography
                sx={{
                  textAlign: 'center',
                  padding: '10px',
                  fontSize: isMobile ? '14px' : '29px',
                  color: 'white',
                  fontWeight: 700,
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  maxWidth: isMobile ? '100px' : '250px'
                }}>
                {item.name}
              </Typography>
            </Box>
          </div>
        ))}
      </div>
    </div>
  );
};
export default Prizes;
